import { useEffect, useState } from "react";
import { Banner, Button, Card, Div, Group, Header, Text, Title } from "@vkontakte/vkui";
import { QRCodeSVG } from "qrcode.react";
import type { Membership } from "../api/types";
import { api, errorMessage } from "../api/client";
import { formatDate, formatMoney } from "../shared/format";
import { Page } from "../components/Page";
import { AccessDenied, ErrorState, LoadingState } from "../components/States";

export function MembershipPage({ navigate }: { navigate: (path: string) => void }) {
  const [membership, setMembership] = useState<Membership | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    api
      .get<{ membership: Membership }>("/membership/me")
      .then((response) => {
        setMembership(response.data.membership);
        setError("");
      })
      .catch((err) => setError(errorMessage(err)))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <Page title="Членская карта">
        <LoadingState />
      </Page>
    );
  }

  if (error && !membership) {
    return (
      <Page title="Членская карта">
        {error.includes("not found") ? <AccessDenied /> : <ErrorState message={error} />}
      </Page>
    );
  }

  if (!membership) {
    return null;
  }

  const expired = membership.status !== "active" || new Date(membership.expiresAt) < new Date();

  return (
    <Page title="Членская карта">
      {expired ? (
        <Banner header="Карта не активна" subheader="Партнёр не сможет зафиксировать скидку по истёкшей или заблокированной карте." />
      ) : null}
      <Group header={<Header>{membership.user?.fullName}</Header>}>
        <div className="club-card">
          <Title level="2">KASS Club</Title>
          <Text>{membership.level} · {membership.status}</Text>
          <div className="club-card-number">{membership.cardNumber}</div>
          <Text>Срок действия: {formatDate(membership.expiresAt)}</Text>
        </div>
        <Div style={{ display: "flex", justifyContent: "center" }}>
          <Card mode="shadow">
            <Div>
              <QRCodeSVG value={membership.cardNumber} size={180} />
            </Div>
          </Card>
        </Div>
      </Group>
      <Group header={<Header>Детали</Header>}>
        <CellLike label="ФИО" value={membership.user?.fullName || "Не указано"} />
        <CellLike label="Уровень" value={membership.level} />
        <CellLike label="Начало" value={formatDate(membership.startsAt)} />
        <CellLike label="Окончание" value={formatDate(membership.expiresAt)} />
        <CellLike label="Экономия" value={formatMoney(membership.totalSaved)} />
        <Button mode="secondary" onClick={() => navigate("/partners")}>
          Смотреть партнёров
        </Button>
      </Group>
    </Page>
  );
}

function CellLike({ label, value }: { label: string; value: string }) {
  return (
    <div className="metric">
      <Text className="muted">{label}</Text>
      <Title level="3">{value}</Title>
    </div>
  );
}
